import React from "react";
import "./Shop.scss";
import { Radio } from "antd";

function Shop({ name, add, code }) {
  return (
    <div className="shop__container">
      <div className="shop__body">
        <div className="shop__left">
          <div className="shop__title">{name}</div>
          <div className="shop__add">{add}</div>
        </div>
        <Radio value={name} code={code} />
      </div>
    </div>
  );
}

export default Shop;
